import api from '../../config/httpClient-commons'

export const getCountries = async () => {
  const request = await api.get('/country');

  return request.data.payload ?? [];
}

export const getDepartments = async (countryId: number) => {
  const request = await api.get(`/departments/${countryId}`);

  return request.data.payload ?? [];
}

export const getProvinces = async (departmentId: number) => {
  const request = await api.get(`/provinces/${departmentId}`);

  return request.data.payload ?? [];
}

export const getDistricts = async (provinceId: number) => {
  const request = await api.get(`/districts/${provinceId}`);

  return request.data.payload ?? [];
}

export const getPositions = async () => {
  const request = await api.get(`/positions`);

  return request.data.payload ?? [];
}

export const getSectors = async () => {
  const request = await api.get(`/sectors`);

  return request.data.payload ?? [];
}

export const getSkillSets = async () => {
  const request = await api.get(`/informatics`);
  return request.data.payload ?? [];
}

export const getGraduations = async () => {
  const request = await api.get(`/graduations`);
  return request.data.payload;
}

export const getUniversities = async () => {
  const request = await api.get(`/universitys`);
  return request.data.payload;
}

export const getSituationList = async () => {
  const request = await api.get(`/situation`);
  return request.data.payload;
}

export const getAreas = async () => {
  const request = await api.get(`/areas`);

  return request.data.payload;
}

export const getSpecialties = async () => {
  const request = await api.get(`/specialties`);
  return request.data.payload;
}

export const getBeneficials = async () => {
  const request = await api.get(`/beneficials`);
  return request.data.payload;
}